import React from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { SponsorCampaignType } from '../../../types/sponsor';

interface SponsorCampaignTypeBadgeProps {
  type: SponsorCampaignType;
  className?: string;
  size?: 'sm' | 'md';
}

export default function SponsorCampaignTypeBadge({
  type,
  className,
  size = 'sm',
}: SponsorCampaignTypeBadgeProps): JSX.Element {
  const { t } = useTranslation();
  const isFeature = type === 'FEATURE';

  return (
    <span
      className={twMerge(
        'inline-flex flex-shrink-0 items-center rounded-full font-semibold',
        size === 'sm' ? 'px-2.5 py-0.5 text-xs' : 'px-3 py-1 text-xs',
        isFeature ? 'bg-primary-300 text-primary-900' : 'bg-primary-100 text-primary-900',
        className,
      )}>
      {t(isFeature ? 'page.sponsors.campaignTypeFeature' : 'page.sponsors.campaignTypeCommunity')}
    </span>
  );
}
